import React from 'react';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from '@/components/ui/table';
import { Progress } from '@/components/ui/progress';

import AppLayout from '../Layouts/AppLayout';
import { useHistorial } from '../../hooks/useHistorial';
import { formatDateLocale, formatTimeLocale } from '@/common/utils/date';
import { useLocation, Navigate } from 'react-router-dom';

const HistorialCambios = () => {
  const { state } = useLocation();
  if (!state?.tramite) return <Navigate to="/" />;
  const { historial, loading } = useHistorial({ tramite: state.tramite });

  return (
    <AppLayout
      title="Historial de cambios"
    >
      <div className="bg-white rounded-md">
        <Table className="table-responsive table-historial">
          <TableHeader>
            <TableRow>
              <TableHead>Usuario</TableHead>
              <TableHead>Nombre</TableHead>
              <TableHead>Fecha</TableHead>
              <TableHead>Hora</TableHead>
              <TableHead>Detalle</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {loading && (
              <TableRow>
                <TableCell colSpan={4}>
                  <Progress value={undefined} className="h-1" />
                </TableCell>
              </TableRow>
            )}
            {historial.map((hist) => (
              <TableRow key={hist.key}>
                <TableCell>{hist.usuario}</TableCell>
                <TableCell>{hist.nombre}</TableCell>
                <TableCell>{hist.fecha ? formatDateLocale(hist.fecha) : '-'}</TableCell>
                <TableCell>{hist.fecha ? formatTimeLocale(hist.fecha) : '-'}</TableCell>
                <TableCell>{hist.detalle}</TableCell>
              </TableRow>
            ))}

          </TableBody>
        </Table>
      </div>
    </AppLayout>
  );
}

export default HistorialCambios;